import { formatRelativeAge } from '../../lib/format';
import { domainOf, safeExternalUrl } from '../../lib/url';
import type { AssistantSource } from '../../types/api';

/**
 * The web pages a reply drew on, numbered, each a link out (new tab, no
 * referrer, no opener) with its host and age. Text only: titles from the web
 * are untrusted and never rendered as HTML, and a URL that is not plain
 * http(s) stays text.
 */
export function AssistantSources({ sources }: { sources: readonly AssistantSource[] }) {
  if (sources.length === 0) return null;
  return (
    <section className="assistant-sources" aria-label="Sources">
      <p className="assistant-sources__title">Sources</p>
      <ol className="assistant-sources__list">
        {sources.map((source, index) => {
          const href = safeExternalUrl(source.url);
          const host = source.source || domainOf(source.url) || '';
          const age = source.published_at ? formatRelativeAge(source.published_at) : null;
          const title = source.title || host || source.url;
          return (
            <li className="assistant-source" key={`${index}:${source.url}`}>
              {href ? (
                <a
                  className="assistant-source__link"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {title}
                  <span className="visually-hidden"> (opens in a new tab)</span>
                </a>
              ) : (
                <span className="assistant-source__text">{title}</span>
              )}
              {host || age ? (
                <span className="assistant-source__meta">
                  {[host, age].filter(Boolean).join(' · ')}
                </span>
              ) : null}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
